import React from "react";
import ReactDOM from "react-dom";
import { Button, Flex, LinkIcon, AddIcon } from "@fluentui/react-northstar";

const COLORS = {
    green: "#107c10",
    yellow: "#F7A827",
    gray: "#8a8a8a",
    purple: "#6264A7",
};

const tooltipWrapperStyle = {
    position: "relative",
    display: "inline-flex",
};

const tooltipStyle = {
    position: "fixed",
    background: "#242424",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    whiteSpace: "nowrap",
    pointerEvents: "none",
    zIndex: 1000000,
    transform: "translateX(-50%) translateY(-100%)",
};

export function TooltipWrapper({ content, children }) {
    const [show, setShow] = React.useState(false);
    const [pos, setPos] = React.useState({ top: 0, left: 0 });
    const ref = React.useRef(null);

    const handleMouseEnter = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            setPos({ top: rect.top - 6, left: rect.left + rect.width / 2 });
        }
        setShow(true);
    };

    return (
        <span
            ref={ref}
            style={tooltipWrapperStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={() => setShow(false)}
        >
            {children}
            {show && ReactDOM.createPortal(
                <span style={{ ...tooltipStyle, top: pos.top, left: pos.left }}>
                    {content}
                </span>,
                document.body
            )}
        </span>
    );
}

function getLinkIconProps(isMapped, syncStatus) {
    if (isMapped && syncStatus === "Active") {
        return {
            title: "Verknüpft & Sync aktiv",
            color: COLORS.green,
            strikethrough: false,
        };
    }
    if (isMapped) {
        return {
            title: "Verknüpft, Sync inaktiv",
            color: COLORS.yellow,
            strikethrough: true,
        };
    }
    return {
        title: "Nicht verknüpft",
        color: COLORS.gray,
        strikethrough: false,
    };
}

function ActionIcons({
    isMapped,
    syncStatus,
    onLinkClick,
    onCreateClick,
    showCreate,
}) {
    const linkProps = getLinkIconProps(isMapped, syncStatus);

    return (
        <Flex gap="gap.smaller" vAlign="center">
            <TooltipWrapper content={linkProps.title}>
                <Button
                    icon={<LinkIcon />}
                    iconOnly
                    text
                    onClick={onLinkClick}
                    styles={{
                        color: linkProps.color,
                        textDecoration: linkProps.strikethrough ? "line-through" : "none",
                        minWidth: "auto",
                        "& svg": { fill: linkProps.color },
                    }}
                />
            </TooltipWrapper>
            {showCreate && (
                <TooltipWrapper content="Mitarbeiter anlegen">
                    <Button
                        icon={<AddIcon />}
                        iconOnly
                        text
                        onClick={onCreateClick}
                        styles={{
                            color: COLORS.purple,
                            minWidth: "auto",
                            "& svg": { fill: COLORS.purple },
                        }}
                    />
                </TooltipWrapper>
            )}
        </Flex>
    );
}

export default ActionIcons;
